import { useState, useEffect } from 'react';
import { Menu } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Sheet, SheetContent, SheetTrigger } from '@/components/ui/sheet';

const navLinks = [
  { name: 'Home', href: '/' },
  { name: 'Capabilities', href: '/capabilities' },
  { name: 'Industries', href: '/industries' },
  { name: 'Founding Team', href: '/team' },
  { name: 'About', href: '/about' },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      style={{
        background: isScrolled ? 'rgba(255,255,255,0.95)' : 'rgba(255,255,255,0.8)',
        backdropFilter: isScrolled ? 'blur(12px)' : 'blur(4px)',
        WebkitBackdropFilter: isScrolled ? 'blur(12px)' : 'blur(4px)',
        boxShadow: isScrolled ? '0 1px 3px rgba(0,0,0,0.08)' : 'none',
      }}
      className="fixed top-0 left-0 right-0 z-50 transition-all duration-500"
    >
      <nav className="container-custom">
        <div className="flex items-center justify-between h-36">
          {/* Logo — Clean, no square container */}
          <Link to="/" className="flex items-center gap-5 group">
            <img
              src="/images/logo.png"
              alt="CoDriverLabs"
              className="h-32 w-auto transition-transform duration-300 group-hover:scale-105"
            />
            <div className="hidden sm:flex flex-col">
              <span className="text-lg text-primary font-semibold tracking-wide leading-tight">
                Guiding Innovation.
              </span>
              <span className="text-lg text-primary font-semibold tracking-wide leading-tight">
                Driving Results.
              </span>
            </div>
          </Link>

          {/* Desktop Navigation — Darker text for readability */}
          <div className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.href}
                className="relative text-sm font-semibold text-slate-800 hover:text-primary transition-colors duration-300 group"
              >
                {link.name}
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-primary transition-all duration-300 group-hover:w-full" />
              </Link>
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden lg:block">
            <Link
              to="/contact"
              className="btn-primary text-sm animate-pulse-glow"
            >
              Book a Call
            </Link>
          </div>

          {/* Mobile Menu */}
          <Sheet open={isOpen} onOpenChange={setIsOpen}>
            <SheetTrigger asChild className="lg:hidden">
              <button className="p-2 text-slate-800">
                <Menu className="w-6 h-6" />
              </button>
            </SheetTrigger>
            <SheetContent
              side="right"
              className="w-[300px] bg-white border-l border-slate-200"
            >
              <div className="flex flex-col gap-6 mt-8">
                {navLinks.map((link) => (
                  <Link
                    key={link.name}
                    to={link.href}
                    onClick={() => setIsOpen(false)}
                    className="text-lg font-semibold text-slate-800 hover:text-primary transition-colors"
                  >
                    {link.name}
                  </Link>
                ))}
                <Link
                  to="/contact"
                  onClick={() => setIsOpen(false)}
                  className="btn-primary text-center mt-4"
                >
                  Book a Call
                </Link>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </nav>
    </header>
  );
}
